import { getToken } from '../../core/utils/apiClient'

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IS_AUTHED = getToken()
